import api from './api';

export interface Brand {
    id: string;
    name: string;
    category?: string;
    description?: string;
    logoUrl?: string;
    createdAt?: string;
}

/** A TopUp bonus tier: load `threshold` € to earn `bonus` € of promotional StoredValue. */
export interface TopUpBonusTier {
    threshold: number;
    bonus: number;
}

export interface BrandInfo {
    id: string;
    name: string;
    logoUrl?: string;
    category?: string;
    description?: string;
    isReferralActive?: boolean;
    pointsExpirationMonths?: number | null;
    posMode?: 'OTP' | 'QR';
    hasStoredValue?: boolean;
    /** Preset recharge amounts (€) the Brand offers; falls back to app defaults when empty. */
    quickAddAmounts?: number[];
    /** Load-threshold → bonus tiers used to preview the promotional StoredValue a recharge grants. */
    topUpBonusTiers?: TopUpBonusTier[];
    /** Whether the Brand has saved its Redsys ("TPV Virtual") credentials. */
    redsysConfigured?: boolean;
    /** Whether the Brand can take an online recharge (StoredValue module on AND Redsys configured). */
    supportsOnlineTopUp?: boolean;
}

export const brandService = {
    getAll: async (): Promise<Brand[]> => {
        try {
            const response = await api.get('/api/brands');
            const data = response.data;

            // Handle wrapped responses
            if (Array.isArray(data)) return data;
            if (data && Array.isArray(data.$values)) return data.$values;
            if (data && Array.isArray(data.brands)) return data.brands;
            if (data && Array.isArray(data.data)) return data.data;

            console.warn('Unexpected brands response shape:', data);
            return [];
        } catch (error: any) {
            if (error.response?.data?.detail) {
                throw new Error(error.response.data.detail);
            }
            throw new Error('Error al obtener los comercios.');
        }
    },

    getBrandInfo: async (brandId: string): Promise<BrandInfo> => {
        try {
            const response = await api.get(`/api/brands/${brandId}`);
            return response.data;
        } catch (error: any) {
            if (error.response?.data?.detail) {
                throw new Error(error.response.data.detail);
            }
            throw new Error('Error al obtener la información del negocio.');
        }
    }
};
